import React from "react";
import {
	DeliveryCreatedMessage,
	DeliveryStatusUpdatedMessage,
} from "@/lib/store/Realtime/message.types";
import { DELIVERY_STATUS_LABELS, DeliveryStatusEnum } from "@/lib/types/delivery.types";

interface DeliveryCreatedBlockProps {
	content: DeliveryCreatedMessage;
}

export const DeliveryCreatedBlock: React.FC<DeliveryCreatedBlockProps> = ({ content }) => {
	const label = content.courier_type === "person" ? "Kurier" : "Versand";
	return (
		<div className="text-sm text-gray-900 leading-relaxed italic">
			Lieferung erstellt — {label}: {content.courier_name}
			{content.description && ` — ${content.description}`}
		</div>
	);
};

interface DeliveryStatusUpdatedBlockProps {
	content: DeliveryStatusUpdatedMessage;
}

export const DeliveryStatusUpdatedBlock: React.FC<DeliveryStatusUpdatedBlockProps> = ({ content }) => {
	const statusLabel = DELIVERY_STATUS_LABELS[content.status as DeliveryStatusEnum] || content.status;
	return (
		<div className="text-sm text-gray-900 leading-relaxed italic">
			Lieferungsstatus: {statusLabel} — {content.courier_name}
			{content.description && ` — ${content.description}`}
		</div>
	);
};
